export default __webpack_public_path__ + "dcfa23d0d7b411b8c4c9c809be501d7f.svg";